import Vue from 'vue';
const resource = '/items';

export default {
  // CUSTOM ENDPOINT
  getByCategoryType(idPublic) {
    return Vue.prototype.$axiosMainClient.get(
      `categorytypes/${idPublic}${resource}`
    );
  },
  getWithItemSuppliers(idPublic) {
    return Vue.prototype.$axiosMainClient.get(
      `${resource}/${idPublic}?include=itemsuppliers`
    );
  },
  getRequested() {
    return Vue.prototype.$axiosMainClient.get(`${resource}/requested`);
  },
  getBySupplier(idPublic) {
    return Vue.prototype.$axiosMainClient.get(
      `suppliers/${idPublic}${resource}`
    );
  },
};
